import DataTableRow from "@eisinc/MobiusOverrides/DataTable/DataTableRow";

export default DataTableRow;

export * from "@eisinc/MobiusOverrides/DataTable/DataTableRow";
